'use strict';

import $ from 'jquery';

/**
 * Indique si un href de stylesheet pointe vers Main.css (chemin Neos ou relatif).
 * @param {string|null|undefined} href
 * @returns {boolean}
 */
export function isMainStylesheetHref(href) {
  if (!href || typeof href !== 'string') {
    return false;
  }
  return /(?:^|\/)Main\.css(?:\?|#|$)/i.test(href) || /Styles\/Main\.css/i.test(href);
}

/**
 * Retrouve le <link> Main.css dans le document.
 * @param {Document} [doc]
 * @returns {HTMLLinkElement|null}
 */
export function findMainStylesheetLink(doc = document) {
  const links = Array.from(doc.querySelectorAll('link[rel="stylesheet"]'));
  return (
    links.find((link) =>
      isMainStylesheetHref(link.getAttribute('href') || link.href || ''),
    ) || null
  );
}

/**
 * Résout quand une feuille de style est appliquée (ou en échec / timeout).
 * @param {HTMLLinkElement|null} link
 * @param {{ timeoutMs?: number }} [options]
 * @returns {Promise<void>}
 */
export function whenStylesheetLoaded(link, options = {}) {
  const timeoutMs = options.timeoutMs ?? 4000;
  if (!link) {
    return Promise.resolve();
  }

  try {
    if (link.sheet) {
      return Promise.resolve();
    }
  } catch (e) {
    // Accès sheet parfois restreint : on attend load/error.
  }

  return new Promise((resolve) => {
    let settled = false;
    const done = () => {
      if (settled) {
        return;
      }
      settled = true;
      resolve();
    };

    link.addEventListener('load', done, { once: true });
    link.addEventListener('error', done, { once: true });

    // Cache navigateur : load peut déjà être passé avant l'écouteur.
    requestAnimationFrame(() => {
      try {
        if (link.sheet) {
          done();
        }
      } catch (e) {
        // Attendre load/error ou timeout.
      }
    });

    // Filet : ne jamais laisser l'UI masquée indéfiniment.
    setTimeout(done, timeoutMs);
  });
}

/**
 * Retire html.loading après application de Main.css (évite le FOUC liens bleus Bootstrap).
 */
const init = () => {
  const $html = $('html');
  const reveal = () => {
    $html.removeClass('loading');
    setTimeout(() => {
      $html.removeClass('no-smooth-scroll');
    }, 500);
  };

  whenStylesheetLoaded(findMainStylesheetLink()).then(reveal);
};

export default { init };
